import axios from "axios";
import { toast } from "react-toastify";

const applyAuthInterceptors = (client: ReturnType<typeof axios.create>) => {
  client.interceptors.request.use(
    async (config) => {
      const token = localStorage.getItem("token");
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );
  client.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error?.response?.status === 401) {
        localStorage.removeItem("token");
        localStorage.removeItem("user_id");
        window.location.href = "/login";
      }
      if (error?.response?.status === 403) {
        const detail = error?.response?.data?.detail;
        toast.error(
          typeof detail === "string" && detail
            ? detail
            : "You do not have permission to access this resource.",
          { toastId: "forbidden", position: "top-center" }
        );
      }
      return Promise.reject(error);
    }
  );
  return client;
};

const apiClient = applyAuthInterceptors(
  axios.create({
    baseURL: process.env.REACT_APP_BASE_URL || "https://api-main.qarshidu.uz/",
    headers: {
      "Content-Type": "application/json",
    },
  })
);

const faceidBaseURL =
  process.env.REACT_APP_FACEID_URL || "https://faceid.qarshidu.uz/";

export const faceidApiClient = applyAuthInterceptors(
  axios.create({
    baseURL: faceidBaseURL,
    headers: {
      "Content-Type": "application/json",
    },
  })
);

export default apiClient;
